import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

export function modelSwiper() {
	document.querySelectorAll('.model-swiper:not(.pa-alternatives-slider)').forEach((el) => {
		new Swiper(el, {
			spaceBetween: 16,
			slidesPerView: 'auto', // Width controlled by CSS classes on each slide
			slidesOffsetAfter: 32,
			modules: [Navigation],

			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},

			breakpoints: {
				640: {
					slidesOffsetAfter: 0,
				},
			},
		});
	});
}
